import { IComment } from "@mctypes/global.types";
import { IMeeting } from "@mctypes/meeting.types";
import React from "react";
import { FailedAlert } from "../../../../../components";
import { useAppSelector } from "../../../../../hooks";
import MultiCommentMantine from "../../../issuesApp/IssuesTab/IssueItemModal/new/MultiCommentMantine";
import { doCreateComment } from "../../../projects/restQueries";
import {
  useAddAgendaCommentMutation,
  useDeleteAgendaCommentMutation,
  useUpdateAgendaCommentMutation,
} from "../../meetingAgendaRTK";

export const AgendaItemComments: React.FC<{
  agendaItem: IMeeting.AgendaItem;
  projectId: string;
  singleMeeting: IMeeting.MeetingPopulated;
}> = ({ agendaItem, projectId, singleMeeting }) => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const [addComment, { isError: addError, isLoading: addLoading }] = useAddAgendaCommentMutation();
  const [deleteComment, { isError: deleteError, isLoading: deleteLoading }] = useDeleteAgendaCommentMutation();
  const [updateComment, { isError: updateError, isLoading: updateLoading }] = useUpdateAgendaCommentMutation();

  const isError = addError || deleteError || updateError;
  const isLoading = addLoading || deleteLoading || updateLoading;

  const onCreateComment = async (text: string, metadata: any) => {
    const createdComment = await doCreateComment(
      project._id,
      agendaItem._id,
      "meetingAgendaItem",
      text,
      singleMeeting._id,
      metadata,
    );
    addComment({
      projectId: projectId,
      agendaId: agendaItem._id,
      commentId: createdComment._id,
    });
  };

  const onDeleteComment = (_id: string): void => {
    deleteComment({ projectId, agendaId: agendaItem._id, commentId: _id });
  };

  const onSaveComment = async (_id: string, text: string, metadata: any): Promise<void> => {
    await updateComment({ projectId, commentId: _id, text, agendaId: agendaItem._id, metadata }).unwrap();
  };

  const user = useAppSelector((state) => state.globalReducer.user);

  return (
    <div>
      {isError === true && <FailedAlert />}
      <MultiCommentMantine
        members={project?.members ?? []}
        sortDesc={true}
        alwaysShowInput={false}
        useBrowserPrompt={true}
        comments={(agendaItem?.comments as IComment[]) ?? []}
        loading={isLoading}
        visibleCommentsOnLoad={5}
        onCreate={onCreateComment}
        onDelete={onDeleteComment}
        onSave={onSaveComment}
        loggedInUser={user}
        allowDelete={true}
        offsetLeft={true}
      />
    </div>
  );
};
